import { useNavigate } from "react-router-dom";
import { Star, MapPin } from "lucide-react";
import { motion } from "framer-motion";
import { imgUrl } from "@/lib/api";

export function VendorCard({ vendor, index = 0 }) {
  const navigate = useNavigate();
  return (
    <motion.button
      data-testid={`vendor-card-${vendor.id}`}
      onClick={() => navigate(`/vendors/${vendor.id}`)}
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: Math.min(index * 0.05, 0.4), duration: 0.4 }}
      className="text-left bg-card rounded-2xl overflow-hidden border border-stone-200 hover:shadow-lg hover:-translate-y-1 transition-transform transition-shadow duration-200 w-full group"
    >
      <div className="relative h-44 overflow-hidden">
        <img
          src={imgUrl(vendor.cover) || "https://images.unsplash.com/photo-1519741196428-6a2175fa2557?w=800&q=80"}
          alt={vendor.name}
          className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
        <div className="absolute top-3 left-3 flex gap-2">
          {vendor.featured && (
            <span className="bg-secondary text-secondary-foreground text-[10px] font-bold px-2 py-1 rounded-full overline">
              Featured
            </span>
          )}
        </div>
        <div className="absolute bottom-3 left-3 right-3 flex items-end justify-between">
          <div>
            <h3 className="text-white font-display font-bold text-lg leading-tight">
              {vendor.name}
            </h3>
            <p className="text-white/80 text-xs flex items-center gap-1 mt-0.5">
              <MapPin className="h-3 w-3" /> {vendor.city}
            </p>
          </div>
          <span className="bg-white/95 text-foreground text-xs font-bold px-2 py-1 rounded-lg flex items-center gap-1">
            <Star className="h-3 w-3 fill-secondary text-secondary" /> {vendor.rating}
          </span>
        </div>
      </div>
      <div className="p-3">
        <div className="flex gap-1.5 overflow-x-auto no-scrollbar">
          {(vendor.tags || []).map((t) => (
            <span
              key={t}
              className="whitespace-nowrap text-[11px] font-semibold text-muted-foreground bg-muted px-2 py-1 rounded-full"
            >
              {t}
            </span>
          ))}
        </div>
        <div className="flex items-center justify-between mt-2 text-xs text-muted-foreground">
          <span>{vendor.reviews} reviews</span>
          <span className="font-semibold text-foreground">{vendor.price_range}</span>
        </div>
      </div>
    </motion.button>
  );
}
